import React from 'react';
import styled from 'styled-components';

interface TextLightScrollProps {
  text: string;
  fontSize?: string;
  className?: string;
}

const TextLightScroll: React.FC<TextLightScrollProps> = ({ text, fontSize = '16px', className }) => {
  return (
    <StyledWrapper className={className} fontSize={fontSize}>
      <span className="text-shine">{text}</span>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div<{ fontSize: string }>`
  .text-shine {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 12px 48px;
    color: #fff;
    background: linear-gradient(to right, #9f9f9f 0, #fff 10%, #868686 20%);
    background-position: 0;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: shine 3s infinite linear;
    animation-fill-mode: forwards;
    -webkit-text-size-adjust: none;
    font-weight: 600;
    font-size: ${props => props.fontSize};
    text-decoration: none;
    white-space: nowrap;
    font-family: "Poppins", sans-serif;
  }
  @-moz-keyframes shine {
    0% {
      background-position: 0;
    }
    60% {
      background-position: 180px;
    }
    100% {
      background-position: 280px;
    }
  }
  @-webkit-keyframes shine {
    0% {
      background-position: 0;
    }
    60% {
      background-position: 180px;
    }
    100% {
      background-position: 180px;
    }
  }
  @-o-keyframes shine {
    0% {
      background-position: 0;
    }
    60% {
      background-position: 180px;
    }
    100% {
      background-position: 180px;
    }
  }
  @keyframes shine {
    0% {
      background-position: 0;
    }
    60% {
      background-position: 280px;
    }
    100% {
      background-position: 280px;
    }
  }`;

export default TextLightScroll;
